// Generated by genversion.
export const version = '5.5.0';
